import React, {useState, useEffect, useRef} from 'react'
import firebase from '../firebase/config'
import ReCAPTCHA from "react-google-recaptcha"
import axios from 'axios'
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
// import { Map, GoogleApiWrapper, Marker  } from 'google-maps-react';
import {useHistory} from 'react-router-dom';

import { Document, Page, pdfjs } from 'react-pdf';
import ControlPanel from '../components/ControlPanel'
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function Register() {

  const history = useHistory()

  const [scale, setScale] = useState(1.0);

	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('')
	const [nombreCompleto, setNombreCompleto] = useState('')
	const [nombreComercial, setNombreComercial] = useState('')
	const [tipoEmpresa, setTipoEmpresa] = useState('')
	const [tipoAliado, setTipoAliado] = useState('')
	const [telefono, setTelefono] = useState('')
	const [identificacion, setIdentificacion] = useState('')
	const [direccion, setDireccion] = useState('')
	const [pais, setPais] = useState('')
	const [tipoMercado, setTipoMercado] = useState('')
	const [cantidadAliados, setCantidadAliados] = useState(0)
	const [latitude, setLatitude] = useState(0)
	const [longitude, setLongitude] = useState(0)
  const [tiposDeAliados, setAliados] = useState([])
  const [paises, setPaises] = useState([])
  const [error, setError] = useState(false)
  const tiposEmpresa = ["Jurídica", "Natural"]
  const [sp, setShowPassword] = useState(false)
  const [imgCharged, setImgCharged] = useState(false)
  const [activePdf, setActivePdf] = useState(false)
  const [emessage, setEmessage] = useState("")
  const hiddenFileInput = React.useRef(null);
  const [countryInfo, setCountryInfo] = useState({})

  const url2 = window.location.href;

  const wrapperRef = useRef(null);

  useOutsideAlerter(wrapperRef, setActivePdf);

  function useOutsideAlerter(ref, state) {
    useEffect(() => {

      function handleClickOutside(event) {
          if (ref.current && !ref.current.contains(event.target)) {
              state(false)
          }
      }
    
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
          document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const [file, setFile] = useState(null);
  const [url, setURL] = useState("");
  const [src, setImg] = useState('');

  const [btnMessage, setBtnMessage] = useState('Regístrate');

  const handleClick = event => {
    hiddenFileInput.current.click();
  };

  function handleChange(e) {
    setImg(URL.createObjectURL(e.target.files[0]));    
    setFile(e.target.files[0]);
    setImgCharged(true)
  }

  const mapStyles = {
    width: '100%',
    height: '100%'
  };  
  
  function getCantidadAliados(){
    let tipos = []
    firebase.db.collection('Aliados').get().then(data=>{  
      data.forEach(tipo=>{
        tipos.push(tipo.data())
      })
      setCantidadAliados(tipos.length)
    }).catch(e=>{
      console.error("Error: " + e)
    })
  }
  
  function getPaisInfo(paiss){
    firebase.getCountryInfo(paiss).then((val)=>{
      setCountryInfo(val.data())
    })
  }
  
  function getPaises(){
    let tipos = []
    firebase.db.collection('Ciudades').get().then(data=>{  
      data.forEach(tipo=>{
        tipos.push(tipo.id)
        tipos.sort()
      })
      setPaises(tipos)
    })
    .catch(e=>{
      console.error("Error paises:",e)
    })
  }
  
  function getAliados(){
    let tipos = []
    firebase.db.collection('TipoAliado').get().then(data=>{  
      data.forEach(tipo=>{
        tipos.push(tipo.id)
        tipos.sort()
      })
      setAliados(tipos)
    })
    .catch(e=>{
      console.error("Error TipoAliado: ",e)
    })  
  }

  const getCountry = () => {
    axios.get("https://ip-api.com/json").then((json)=>{
      setPais(json.data.country)
      getPaisInfo(json.data.country)
    })
  }

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  useEffect(()=>{
    navigator.geolocation.getCurrentPosition(function(position) {
      setLatitude(position.coords.latitude)
      setLongitude(position.coords.longitude)
    });
    getAliados();
    getCantidadAliados();
    getPaises();
    getCountry()
  },[]);

  return (
    <main className="container">
      {error 
      ? <div className="alert alert-danger alert-dismissible fade show mb-0 mt-2" role="alert">
              <button onClick={()=>{setError(false)}} className="close" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">×</span>
              </button>
              <i className="fa fa-exclamation-triangle mx-2"></i>
              <strong>Cuidado!</strong> {emessage}
          </div>
      : <div></div>
      }
      <div className="h-100vh row no-gutters flow-column align-items-center">
        <form className="bg-white p-5 rounded mt-5 w-100" onSubmit={e => e.preventDefault() && false }>
            <div className="row mb-5">
              <div className="form-register-image mx-auto">
                <img src="../images/logo.png" alt="Priority Pet Aliados"/>
              </div>
              <input type="file"
                ref={hiddenFileInput}
                onChange={handleChange} 
                style={{display: 'none'}}
              />
              <div onClick={handleClick} className="register-img">
                {src !== "" ? <img src={src} alt="" /> : <div className="register-img-upload"><p className="icon mb-0">Foto o logo
                {/* <span className="material-icons">add</span> */}
                </p></div>}
              </div>
            </div>
                  <div className="form-row">
                    <div className="form-group col-md-6">
                      <select className="form-control" value={pais} onChange={(e) => {setPais(e.target.value); getPaisInfo(e.target.value)}}>
                        <option value="">Selecciona tu país</option>
                        {paises.map(data => (
                            <option key={data} value={data}>{data}</option>
                        ))}
                      </select>
                    </div>
                    
                    <div className="form-group col-md-6">
                      <input type="text" className="form-control" onChange={(e) => setNombreComercial(e.target.value)} placeholder="Nombre comercial" value={nombreComercial} />
                    </div>

                  </div>

                  <div className="form-row">

                    <div className="form-group col-md-6">
                      <input type="email" className="form-control" onChange={(e) => setEmail(e.target.value)} placeholder="Email" value={email} />
                    </div>
                                            
                    <div className="form-group col-md-6">
                      <input type="text" className="form-control" onChange={(e) => setIdentificacion(e.target.value)} placeholder="Identificación" value={identificacion} />
                    </div>

                  </div>

                  <div className="form-row">
                    
                    <div className="form-group col-md-6">
                      <input type="text" className="form-control" onChange={(e) => setNombreCompleto(e.target.value)} placeholder="Nombre completo" value={nombreCompleto} />
                    </div>

                    <div className="form-group col-md-6">
                      <select className="form-control" value={tipoEmpresa} onChange={(e) => setTipoEmpresa(e.target.value)}>
                        <option value="">Selecciona tu tipo de empresa</option>
                        {tiposEmpresa.map(data => (
                            <option key={data} value={data}>{data}</option>
                        ))}
                      </select>
                    </div>

                  </div>

                  <div className="form-row">
                    
                    <div className="form-group col-md-6">
                      <select className="form-control" value={tipoMercado} onChange={e => setTipoMercado(e.target.value)}>
                        <option value="">Selecciona el tipo de tu mercado</option>
                        <option value="Mayorista">Mayorista</option>
                        <option value="Minorista">Minorista</option>
                        <option value="Mixto">Mixto</option>
                      </select>
                    </div>

                  </div>

                  <div className="form-row">

                    <div className="form-group col-md-6">
                      <select className="form-control" value={tipoAliado} onChange={e => setTipoAliado(e.target.value)}>
                        <option value="">Selecciona el tipo de aliado</option>
                        {tiposDeAliados.map(data => (
                            <option key={data} value={data}>{data}</option>
                        ))}
                      </select>
                    </div>

                    <div className="form-group col-md-6"> <PhoneInput defaultCountry={countryInfo.codigoTexto} placeholder="Teléfono" value={telefono} onChange={setTelefono}/> </div>

                  </div>

                  <div className="form-row">
                    
                    <div className="form-group col-md-6">
                      <input type="text" className="form-control" onChange={(e) => setDireccion(e.target.value)} placeholder="Dirección" value={direccion} />
                    </div>
                    
                    <div className="form-group col-md-6">
                      <div className="row align-items-center">
                        <div className="col-md-11">
                          <input type={sp ? "text" : "password"} className="form-control" onChange={(e) => setPassword(e.target.value)} placeholder="Contraseña" value={password} />
                        </div>
                        <span onClick={()=>{setShowPassword(!sp)}} className="material-icons mb-0">{sp ? "visibility_off" : "visibility" }</span>
                      </div>
                    </div>

                  </div>

                  <div className="form-row align-items-center">
                    <div className="col-lg-5 row no-gutters justify-content-space-between align-items-center">
                      <input type="checkbox" name="ab"/>
                      <div className="col-lg-10 text-left ml-3">Acepto el acuerdo de <span onClick={()=>{setActivePdf(true)}} className="color-primary cursor-pointer">términos y condiciones</span></div>
                    </div>
                    <div className="col-lg-7 row no-gutters align-items-center justify-content-spacebetween">  
                      <ReCAPTCHA onErrored={(e)=>{ e.reset(); }}  onExpired={(e)=>{ console.log("Expired") }} sitekey={ url2.includes("prioritypet-aliados") || url2.includes("localhost") ? "6Leo8c8aAAAAAG8zagtbWvRX-rxjk7oLSverP4nV" : "6LfjV0AbAAAAAI_JNbPvoQMbr1SLPc53kxfcjDqI"} onChange={(v)=>{ onChange(v) }} />
                      <button onClick={()=>{ btnMessage !== "Cargando..." && onRegister() }} className="btn btn-primary registrate-btn col-lg-5 btn-block mr-0">{btnMessage}</button>
                    </div>
                  </div>
        </form>
      </div>
      {/* <Map
        google={window.google}
        zoom={14}
        style={mapStyles}
        initialCenter={{
          lat: latitude,
          lng: longitude
        }}
      /> */}
        { activePdf && <div className="rpdf-component-wrapper">
          <div className="rpdf-component" ref={wrapperRef} >
            <ControlPanel
              scale={scale}
              setScale={setScale}
              numPages={numPages}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              file="/terminos-condiciones.pdf"
            />
            <Document className="rpdf-component-file" onLoadError={console.error} file="/terminos-condiciones.pdf" onLoadSuccess={onDocumentLoadSuccess}>
              <Page height={600} pageNumber={pageNumber} />
            </Document>
          </div>
        </div> }
        
      </main>
    )

    function onChange(value) {
      value.reset();
      console.log("Captcha value:", value)
    }

    async function approveUser(id){

      var config = {
        headers: {
          'Content-type': 'application/json; charset=utf-8',
          'Access-Control-Allow-Origin':'*',
          'Access-Control-Allow-Methods': 'POST',
          'Access-Control-Allow-Headers':'Content-Type',
          // 'Access-Control-Allow-Credentials': true,
          'cache-control': 'no-cache'
        }
      };

      const notificationData = { id: id };
      axios.post('https://us-central1-priority-pet.cloudfunctions.net/aikonsPayCreateSeller', notificationData, config).then((response)=>{
        alert(response)
      });

    }

    async function onRegister() {
		try {
      if(
        email !== '' &&
        password !== '' &&
        nombreCompleto !== '' &&
        nombreComercial !== '' &&
        tipoEmpresa !== '' &&
        tipoAliado !== '' &&
        telefono !== '' &&
        identificacion !== '' &&
        direccion !== '' &&
        imgCharged
      ){
        const userInfo = {
          nombre: nombreCompleto,
          nombreComercial: nombreComercial ?? nombreCompleto,
          tipoEmpresa: tipoEmpresa,
          tipoMercado: tipoMercado,
          tipoAliado: tipoAliado, 
          telefono: telefono,
          identificacion: identificacion,
          role: "Administrador",
          direccion: direccion,
          cantidadAliados: cantidadAliados,
          codigoArea: countryInfo.codigoArea.replace('+', ''),
          pais: pais
        }
        setBtnMessage("Cargando...")
        await firebase.register(email, password)
        await firebase.storage.ref(`/Aliados imagenes/${file.name}`).put(file)
        await firebase.storage.ref("Aliados imagenes").child(file.name).getDownloadURL().then((urlI) => {
          firebase.addUser(email, userInfo, urlI).then((val)=>{
            axios.get(`https://us-central1-priority-pet.cloudfunctions.net/sendWelcomeEmail?dest=${email}&username=${userInfo.nombreCompleto}`)
            if(userInfo.tipoAliado === "Médico"){
              window.location.href = "/register/doctor_register";
            }else{
              window.location.href = "/";
            }
          })
        })
      }else{
        setError(true)
        setTimeout(() => {
      		  setError(false)
      		}, 4000);
        setEmessage("Todos los campos son obligatorios");
      }
		} catch(e) {
      switch(e.message) { 
				case "The email address is badly formatted.":
					setError(true)
          setTimeout(() => {
      		  setError(false)
      		}, 4000);
					setEmessage("Debes ingresar un email correcto");
				break;
				case "There is no user record corresponding to this identifier. The user may have been deleted.":
					setError(true)
          setTimeout(() => {
      		  setError(false)
      		}, 4000);
					setEmessage( "El usuario no existe");
				break;
				case "The password is invalid or the user does not have a password.":
					setError(true)
          setTimeout(() => {
      		  setError(false)
      		}, 4000);
					setEmessage("Contraseña incorrecta. Intenta ingresar la correcta");
				break;
				case "The email address is already in use by another account.":
					setError(true)
          setTimeout(() => {
      		  setError(false)
      		}, 4000);
					setEmessage("Tu cuenta ya está registrada con nosotros, si deseas hacer algún cambio o una compra descarga nuestra aplicación.");
					
				break;
				case "Password should be at least 6 characters":
					setError(true)
          setTimeout(() => {
      		  setError(false)
      		}, 4000);
					setEmessage("La contraseña debe ser mayor a 5 caracteres");
					
				break;
				default:
					setError(true)
          setTimeout(() => {
      		  setError(false)
      		}, 4000);
					setEmessage(e.message);
		
				break; 
			}
			// alert(error.message)
		}
	}

}

export default Register